import React from 'react'
import i18n from '../../../i18n/i18n'
import { Dropdown, Option } from '../../common/Dropdown'
import { Button } from '../../common/Button'
import { LocalStorageKeys } from '../../../types/local-storage'
import { getLanguage, getLanguageOption } from '../../../helpers/i18n'

export interface LanguagePicker {
  className?: string
}

export const LanguagePicker = ({ className }: LanguagePicker): JSX.Element => {
  const swedish = {
    label: 'Svenska 🇸🇪',
    value: 'sv-SE',
  }
  const english = {
    label: 'English 🇬🇧',
    value: 'en-EN',
  }
  const finnish = {
    label: 'Suomi 🇫🇮',
    value: 'fi-FI',
  }

  const changeLanguage = (locale: string): void => {
    localStorage.setItem(LocalStorageKeys.LOCALE, locale)
    i18n.changeLanguage(locale)
    document.documentElement.lang = getLanguage(locale)
  }

  const languageOptions: Option[] = [
    { ...swedish, onClick: () => changeLanguage(swedish.value) },
    { ...english, onClick: () => changeLanguage(english.value) },
    { ...finnish, onClick: () => changeLanguage(finnish.value) },
  ]

  const selectedLanguage = getLanguageOption(i18n.language)

  return (
    <div className={className ?? ''}>
      <Dropdown options={languageOptions}>
        <Button label={selectedLanguage.label} value={selectedLanguage.value} />
      </Dropdown>
    </div>
  )
}
